export const alumni = [
    {
        name: 'Akaash Trivedi', 
        role: 'Project Lead & Developer',
        imageUrl: 'https://smar-team.s3.us-west-1.amazonaws.com/profile-photo/AkaashTrivedi.jpg',
        linkedInUrl: 'https://www.linkedin.com/in/akaash-trivedi/',
        bio: 'Akaash is a an accomplished Software Engineer with over four years of experience across the Semiconductor, Cybersecurity, and Fintech domains.'
    },
    {
        name: 'Vaishnavi Upadhye', 
        role: 'Developer',
        imageUrl: 'https://smar-team.s3.us-west-1.amazonaws.com/profile-photo/VaishnaviUpadhye.jpeg',
        linkedInUrl: 'https://www.linkedin.com/in/vaishnaviupadhye/',
        bio: 'Vaishnavi was previously a member of the developer team for SMAR.'
    },
    {
        name: 'Rani Rajurkar', 
        role: 'Technical Consultant',
        imageUrl: 'https://smar-team.s3.us-west-1.amazonaws.com/profile-photo/RaniRajurkar.jpeg',
        linkedInUrl: 'https://www.linkedin.com/in/rani-rajurkar/',
        bio: 'Rani was previously a member of the technical consulting team for SMAR.'
    },
    {
        name: 'Juilee Katpatal', 
        role: 'Technical Consultant',
        imageUrl: 'https://smar-team.s3.us-west-1.amazonaws.com/profile-photo/JuileeKatpatal.jpeg',
        linkedInUrl: 'https://www.linkedin.com/in/zuilee/',
        bio: 'Juilee was previously a member of the technical consulting team for SMAR.'
    },
    {
        name: 'Soumya Mohan', 
        role: 'Scrum Coach',
        imageUrl: 'https://smar-team.s3.us-west-1.amazonaws.com/profile-photo/SoumyaMohan.jpeg',
        linkedInUrl: 'https://www.linkedin.com/in/soumyaiim/',
        bio: 'Results-driven Full Stack Product Manager with 7 years of experience leading 0-1 product development in AdTech, FinTech, and B2B SaaS.  Skilled in defining and executing product vision and strategic roadmaps, I excel in partnering with cross-functional teams to build and scale innovative products.  With deep expertise in AI/ML, data analytics, and software engineering, I leverage data-driven insights to optimize user experiences and accelerate product adoption, consistently driving business outcomes.'
    },
];